
export default {
  name: 'AppInfoBox',
  props: {
    title: { type: String, required: true }
  }
};
